export function convertArrayToDictionary<T extends { id: number }>(
  array: T[],
): Record<number, T> {
  const result: Record<number, T> = {};
  array.forEach((x) => {
    result[x.id] = x;
  });
  return result;
}
